"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M9.99997 5.99975C11.173 5.99975 12.124 6.90075 12.124 8.01475C12.124 9.12675 11.173 10.0288 9.99997 10.0288C8.82697 10.0288 7.87597 9.12675 7.87597 8.01475C7.87597 6.90075 8.82697 5.99975 9.99997 5.99975ZM14.31 9.44375C15.24 9.87075 15.906 10.7308 15.999 11.7528C16.012 11.8858 15.892 11.9998 15.751 11.9998H14.007H13.532L13.282 12.4747C13.112 12.7967 12.766 12.9998 12.386 12.9998H7.61397C7.23397 12.9998 6.88797 12.7967 6.71797 12.4747L6.46797 11.9998H5.99297H4.24897C4.10797 11.9998 3.98797 11.8858 4.00097 11.7528C4.09397 10.7318 4.75997 9.87075 5.68897 9.44475C5.86897 9.36275 5.99297 9.20175 5.99297 9.01275V6.99975C5.99997 4.99975 8.59797 2.85675 9.60697 2.12675C9.83997 1.95775 10.16 1.95775 10.393 2.12675C11.402 2.85675 14 4.99975 14.007 6.99975V9.01475C14.007 9.20175 14.131 9.36275 14.31 9.44375ZM12.6358 13.9998C12.8078 13.9998 12.9368 14.1667 12.8768 14.3278C12.4298 15.5428 9.99977 17.9998 9.99977 17.9998C9.99977 17.9998 7.57077 15.5428 7.12277 14.3278C7.06377 14.1667 7.19277 13.9998 7.36477 13.9998H8.77977C8.90577 13.9998 8.99977 14.0957 9.02777 14.2188C9.18777 14.9277 9.99977 15.9998 9.99977 15.9998C9.99977 15.9998 10.8128 14.9277 10.9728 14.2188C10.9998 14.0957 11.0948 13.9998 11.2208 13.9998H12.6358Z",
    fill: "#727B7F"
  }));
};